import { render } from "./game-post.vue?vue&type=template&id=58c3e368"
import script from "./game-post.vue?vue&type=script&lang=js"
export * from "./game-post.vue?vue&type=script&lang=js"

import "./game-post.vue?vue&type=style&index=0&id=58c3e368&lang=scss"

import exportComponent from "/tmp/build_ed238492/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__